import { ReactNode } from 'react';

import { LessonProgressCard } from '@/components/lesson/LessonProgressCard';
import Lesson from '@/models/Lesson';
import { LessonItem } from '@/utils/lesson/lessonItems';
import { toLessonTabHref } from '@/utils/lesson/lessonTabs';
import { CourseRoute, ROUTES } from '@/utils/routes';

type UnitLessonCardProps = CourseRoute & {
  lesson: Pick<Lesson, 'id' | 'bannerImg' | 'description'>;
  name: string;
  items: LessonItem[];
  highlighted?: boolean;
  children?: ReactNode;
};

export default function UnitLessonCard({
  lesson,
  name,
  items,
  highlighted,
  children,
  slug,
  klassId,
}: UnitLessonCardProps) {
  const route = { slug, lessonId: lesson.id, klassId };
  const href = ROUTES.COURSES.LESSON.INFO(slug, lesson.id, klassId);

  return (
    <li>
      <LessonProgressCard highlighted={highlighted}>
        {children}
        <LessonProgressCard.Banner src={lesson.bannerImg} />
        <LessonProgressCard.Title href={href}>{name}</LessonProgressCard.Title>
        <LessonProgressCard.Description>
          {lesson.description}
        </LessonProgressCard.Description>
        <LessonProgressCard.Items>
          {items.map(item => (
            <LessonProgressCard.Item
              key={item.type}
              {...item}
              href={toLessonTabHref(route, item.type) ?? href}
            />
          ))}
        </LessonProgressCard.Items>
      </LessonProgressCard>
    </li>
  );
}
